import { render, staticRenderFns } from "./layout-sider.vue?vue&type=template&id=ac4360f6&scoped=true&"
import script from "./layout-sider.vue?vue&type=script&lang=js&"
export * from "./layout-sider.vue?vue&type=script&lang=js&"
import style0 from "./layout-sider.vue?vue&type=style&index=0&id=ac4360f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4360f6",
  null
  
)

export default component.exports